import * as React from 'react'
import GalleryFlowObject from '../../model/GalleryFlowObject'
import ImageFlowObject from '../../model/ImageFlowObject'
import PdfFlowObject from '../../model/PdfFlowObject'
import VideoFlowObject from '../../model/VideoFlowObject'
import { applyRatio, rotationToDeg } from './helpers'
import { MMOOptions } from './mmo-interactor'

interface AVMediaViewOptions {
    mmo: ImageFlowObject | VideoFlowObject | PdfFlowObject | GalleryFlowObject
}

export const AVMediaView: React.FC<AVMediaViewOptions & MMOOptions> = (props) => {
    const { mmo } = props
    const scaledObjects = applyRatio({
        left: mmo.frame.x,
        top: mmo.frame.y,
        width: mmo.frame.width,
        height: mmo.frame.height,
    }, props.size.ratio)

    function imageToShowHelper() {
        if (mmo.croppedImageAsset && mmo.croppedImageAsset.externalURL.__tag === "string") {
            return mmo.croppedImageAsset.externalURL.value
        } else {
            return mmo.originalImageAsset?.externalURL.value as string
        }
    }

    const imageToShow = React.useMemo(() => imageToShowHelper(), [mmo.croppedImageAsset, mmo.originalImageAsset])

    return (
        <img
            src={imageToShow}
            crossOrigin="anonymous"
            style={{
                ...scaledObjects,
                position: "absolute",
                transform: `rotate(${rotationToDeg(mmo.rotation)}deg)`,
                border: `${mmo.borderWidth}px solid ${mmo.borderColor.asRgba()}`,
                borderRadius: `${mmo.cornerRadius}px`
            }}
            id={mmo.id.replace(/-/g, "")}
            ref={props.forwardedRef}
            className="mmo"
            {...props}
            onClick={(e) => props.onClick(e)}
            onMouseEnter={(e) => props.onMouseEnter(e)}
            onMouseLeave={(e) => props.onMouseLeave(e)}
        />
    )
}